import React from "react";
import Dialog from "@material-ui/core/Dialog";
import { withStyles } from "@material-ui/core/styles";
import CloseIcon from '@material-ui/icons/Close';
import './PrescriptionView.css';


const styles = {};
export default class PerscriptionView extends React.Component {
  constructor(props) {
    super(props);
    this.state = { cancel: null,view:false,pres:true,claim:false };
  }
  handleClose = () => {
    this.props.onClose(this.props.selectedValue);
  };
  CliamOpen=()=>
  {
    this.setState({pres:false,claim:true})
  }
  PresOpen=()=>
  {
    this.setState({claim:false,pres:true})
  }

  render() {
    const styles = "";
    const { classes, onClose, cancel, selectedValue, ...other } = this.props;
    return (
      <div>
      
        <Dialog
          onClose={this.handleClose}
          aria-labelledby="simple-dialog-title"
          {...other}
          fullWidth={true}
          maxWidth={this.props.xswidth==="xs" ? 'xs' : this.props.xswidth==="lg" ?"lg":"md"}
        >
         {/* <CloseIcon className="presmodal_close" onClick={this.props.onClose}/> */}
         <CloseIcon className={`${this.props.i18n.language == 'ar' ? "arabpresmodal_close" : "presmodal_close"} `} onClick={this.props.onClose}/>
           {this.state.pres&&<div className="prescription_div">
               <div className="prescrip_text">PRESCRIPTION</div>
               <img src={this.props.fileName} className="pres_form"/>
               {/* <div className="claim_container"><label>CLAIM FORM</label><ChevronRightIcon className="claim_move" onClick={this.CliamOpen}/></div> */}
           </div>}
             {/* {this.state.claim&&
           <div className="prescription_div">
               <div className="prescrip_text">CLAIMFORM</div>
               <img src={Pres2} className="pres_form"/>
               <div className="presview_container"><ChevronLeftIcon className="claim_move" onClick={this.PresOpen}/><label>PRESCRIPTION</label></div>
           </div>} */}
          
  
        </Dialog>
          
      </div>
    );
  }
}
const Trainer_viewWrapped = withStyles(styles)(PerscriptionView);
